
import React from 'react';
import { FacilityOrderTemplateMissingDocumentNoteModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateMissingDocumentNoteModalStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateMissingDocumentNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateMissingDocumentNoteModalStore')
@observer
class FacilityOrderTemplateMissingDocumentNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateMissingDocumentNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateMissingDocumentNoteModal;
